export default __webpack_public_path__ + "static/media/pic3.b5dbc49c.jpg";